import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';
import { newsTranslations } from '../data/translations/newsTranslations';
import NewsletterSignup from '../components/NewsletterSignup';

export default function NewsArchive() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = newsTranslations[language].news;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handlePostClick = (post) => {
    if (post.internal) navigate(`/news/${post.id}`);
    else window.open(post.link, '_blank');
  };

  return (
    <div className="flex flex-col min-h-screen bg-background text-on-surface font-body">
      <Navbar />

      <main className="flex-grow pt-28 pb-24 px-4 sm:px-8">
        <div className="max-w-5xl mx-auto">

          {/* Back link */}
          <button
            onClick={() => navigate('/#news')}
            className="flex items-center gap-2 text-muted hover:text-secondary text-xs font-black uppercase tracking-widest transition-colors mb-12 group"
          >
            <span className="material-symbols-outlined text-sm group-hover:-translate-x-1 transition-transform duration-200">west</span>
            {language === 'es' ? 'Volver al inicio' : 'Back to home'}
          </button>

          {/* Header */}
          <div className="border-b border-border pb-6 mb-16">
            <h1 className="font-headline text-4xl md:text-5xl font-extrabold text-primary uppercase tracking-tight">
              {t.title}
              <span className="block w-24 h-1 bg-secondary mt-4" />
            </h1>
          </div>

          {/* All posts */}
          <div className="flex flex-col gap-4">
            {t.posts.map((post) => (
              <article
                key={post.id}
                onClick={() => handlePostClick(post)}
                className="relative overflow-hidden rounded-2xl border border-border bg-surface cursor-pointer group flex flex-row h-36 hover:border-secondary/30 hover:shadow-xl transition-all duration-300 shadow-sm"
              >
                {/* Image */}
                <div className="relative w-48 flex-shrink-0 overflow-hidden">
                  {post.image ? (
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-secondary/30 to-primary/10" />
                  )}
                  <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-r from-transparent to-surface" />
                </div>

                {/* Content */}
                <div className="flex flex-col justify-center px-6 py-4 flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="px-3 py-1 bg-secondary/10 text-secondary font-black text-[10px] uppercase tracking-[0.15em] rounded-full">
                      {post.source}
                    </span>
                    <span className="text-muted font-mono text-xs">{post.date}</span>
                  </div>
                  <h2 className="font-headline font-extrabold text-primary text-base leading-snug line-clamp-2 mb-2">
                    {post.title}
                  </h2>
                  <div className="flex items-center gap-2 text-secondary font-bold text-xs uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {post.readMore}
                    <span className="material-symbols-outlined text-sm group-hover:translate-x-1 transition-transform duration-300">east</span>
                  </div>
                </div>

                {/* Bottom accent */}
                <div className="absolute bottom-0 left-0 h-0.5 bg-secondary w-0 group-hover:w-full transition-all duration-700 ease-in-out" />
              </article>
            ))}
          </div>

          {/* Subscription Section */}
          <div className="mt-20 pb-10">
            <NewsletterSignup />
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}
